// libs
import isEmpty from "lodash/isEmpty";

// helpers
import { getCookie, setCookie } from "shared/helpers/utils";

// redux
import { getRemoteConfig } from "shared/store/remoteConfigs/selectors";

// constants
import {
    TEXTS,
    LOGIN_ERROR_COOKIE,
    VALID_LOGIN_ERROR,
    QUERY_STRING_AUTH_INITIATER,
    QUERY_STRING_AUTH_VALUE,
} from "./constants";

// eslint-disable-next-line no-useless-escape
const emailRegex = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
export const validateEmail = (email: string) => {
    if (isEmpty(email)) {
        return {
            status: false,
            error: TEXTS.EMAIL_REQUIRED,
        };
    }

    if (emailRegex.test(email.toLowerCase()) === false) {
        return {
            status: false,
            error: TEXTS.EMAIL_INVALID,
        };
    }

    return { status: true };
};

export const validatePassword = (password: string) => {
    if (isEmpty(password)) {
        return {
            status: false,
            error: TEXTS.PASSWORD_REQUIRED,
        };
    }

    return { status: true };
};

const nameRegex = /^[a-z\s]+$/i;
export const validateName = (name: string) => {
    if (isEmpty(name)) {
        return {
            status: false,
            error: TEXTS.NAME_REQUIRED,
        };
    }

    if (nameRegex.test(name) === false) {
        return {
            status: false,
            error: TEXTS.NAME_INVALID,
        };
    }

    return { status: true };
};

export const hasSocialLoginError = () => {
    const loginErrorCookie = getCookie(LOGIN_ERROR_COOKIE);

    return (
        isEmpty(loginErrorCookie) === false &&
        String(loginErrorCookie).toLowerCase() === VALID_LOGIN_ERROR
    );
};

export const clearLoginError = () => {
    setCookie(LOGIN_ERROR_COOKIE, "", 0);
};

export const isShowAuthRequested = (search = "") => {
    const urlParams = new URLSearchParams(search);

    return (
        urlParams.has(QUERY_STRING_AUTH_INITIATER) &&
        // @ts-ignore
        urlParams.get(QUERY_STRING_AUTH_INITIATER).toLowerCase() === QUERY_STRING_AUTH_VALUE
    );
};

export const getAuthRedirectUrl = () => {
    if (isEmpty(document.referrer)) {
        return undefined;
    }

    try {
        const referrerUrl = new URL(document.referrer);

        // return referrer only if matches our host
        if (window.location.host !== referrerUrl.host) {
            return undefined;
        }

        return document.referrer;
    } catch (e) {
        return undefined;
    }
};

export const getOTPFlowStatus = (state: any) => {
    let isOTPFlowEnabledForMobile = false;
    let isOTPFlowEnabledForDesktop = false;

    try {
        const { isEnabledForMobile, isEnabledForDesktop } = JSON.parse(
            getRemoteConfig(state, "otp_flow")
        );
        isOTPFlowEnabledForMobile = isEnabledForMobile;
        isOTPFlowEnabledForDesktop = isEnabledForDesktop;
    } catch (err) {
        // do Nothing
    }

    return { isOTPFlowEnabledForMobile, isOTPFlowEnabledForDesktop };
};
